/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, OnDestroy, OnInit } from '@angular/core';

import { AppUtilityService } from './../../services/app-utility.service';
import { ConfigService } from './../../services/config.service';
import { LmsModuleService } from './../../services/lms-module.service';
import { Tab } from './../../model/tab.model';
import { environment } from './../../../../environments/environment';

/**
 * This header component is created for application header.
 * @export
 * @class LmsHeaderComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-header',
  templateUrl: './lms-header.component.html',
  styleUrls: ['./lms-header.component.scss']
})
export class LmsHeaderComponent implements OnInit, OnDestroy {
  csxLogo;

  selectedTab: Tab;

  tabSubscription: any;
  maintenanceMsg: any;

  /**
   * Creates an instance of ConfigService.
   * @param {ConfigService} configService
   * @memberOf LmsHeaderComponent
   */
  constructor(private configService: ConfigService,
    private lmsModuleService: LmsModuleService, private appUtilityService: AppUtilityService) { }

  /**
   * This method invoked when component is load, it initialize the logo for application.
   * @memberOf LmsHeaderComponent
   */
  ngOnInit() {
    this.tabSubscription = this.lmsModuleService.selectedTab.subscribe(data => {
      this.selectedTab = data;
      document.title = 'LMS' + ((this.selectedTab.type) ? ' - ' : '') + ((this.selectedTab.type) ? this.selectedTab.type : '');
    });
    this.csxLogo = this.configService.getConfigData().images.csxLogo;

    let effectiveStrDate = environment.appConfig.maintenance.effectiveDate;
    let expireStrDate = environment.appConfig.maintenance.expireDate;
    let showMaintenanceMsg = false;
    if(effectiveStrDate && expireStrDate) {
      let todayDate = new Date();
      let effectiveDate = new Date(effectiveStrDate);
      let expireDate = new Date(expireStrDate);
      if(effectiveDate.getTime() <= todayDate.getTime() && expireDate.getTime() > todayDate.getTime()) {
        showMaintenanceMsg = true;
      }
    }
    if(showMaintenanceMsg) {
      this.maintenanceMsg = environment.appConfig.maintenance.message;
    } else {
      this.maintenanceMsg = '';
    }

  }

  /**
   * @memberOf LmsHeaderComponent
   */
  ngOnDestroy() {
    this.tabSubscription.unsubscribe();
  }

}
